// Configuration for Statecraft Web UI
// This file centralizes all configuration settings and supports environment variables

const config = {
  // API Configuration
  api: {
    // Base URL for the Statecraft API
    // Can be overridden with REACT_APP_API_URL environment variable
    baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:8080',
    
    // API version prefix
    version: '/api/v1',
    
    // Request timeout in milliseconds
    timeout: 10000,
  },
  
  // Application Configuration
  app: {
    name: 'Statecraft Web UI',
    version: '1.0.0',
    
    // Local storage keys
    storage: {
      sessionKey: 'statecraft-session',
      authKey: 'statecraft-auth',
    },
    
    // JWT token configuration
    jwt: {
      // Token expiration buffer (refresh before actual expiry)
      expirationBuffer: 5 * 60 * 1000, // 5 minutes in milliseconds
    },
  },
  
  // UI Configuration
  ui: {
    // Theme colors
    theme: {
      primary: '#667eea',
      secondary: '#764ba2',
      background: '#f5f5f5',
    },
    
    // Avatar settings
    avatar: {
      defaultSize: 40,
      largeSize: 80,
    },
    
    // Pagination settings
    pagination: {
      defaultPageSize: 10,
      maxPageSize: 100,
    },
  },
  
  // External services
  external: {
    // Minecraft username to UUID resolution services
    mojang: {
      // CORS proxies for Mojang API access
      corsProxies: [
        'https://api.allorigins.win/get?url=',
        'https://corsproxy.io/?',
      ],
      apiUrl: 'https://api.mojang.com/users/profiles/minecraft/',
    },
  },
};

// Helper function to get full API URL
export const getApiUrl = (endpoint = '') => {
  const baseUrl = config.api.baseUrl.endsWith('/') 
    ? config.api.baseUrl.slice(0, -1) 
    : config.api.baseUrl;
  
  const version = config.api.version;
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  
  return `${baseUrl}${version}${cleanEndpoint}`;
};

// Helper function to get API base URL without version
export const getApiBaseUrl = () => {
  return config.api.baseUrl.endsWith('/') 
    ? config.api.baseUrl.slice(0, -1) 
    : config.api.baseUrl;
};

// Helper function to check if API URL is configured
export const isApiConfigured = () => {
  return config.api.baseUrl && config.api.baseUrl !== '';
};

// Helper function to get configuration value with fallback
export const getConfigValue = (path, fallback = null) => {
  const keys = path.split('.');
  let current = config;
  
  for (const key of keys) {
    if (current && typeof current === 'object' && key in current) {
      current = current[key];
    } else {
      return fallback;
    }
  }
  
  return current;
};

// Export the main configuration object
export default config; 